import { Link } from "react-router-dom";
import { Twitter, Linkedin, Github, Youtube } from "lucide-react";
import Logo from "@/components/Logo";
import NewsletterForm from "@/components/NewsletterForm";
import { FOOTER } from "@/lib/site";

const SOCIALS = [
  { icon: Twitter, label: "Twitter", href: "https://twitter.com" },
  { icon: Linkedin, label: "LinkedIn", href: "https://linkedin.com" },
  { icon: Github, label: "GitHub", href: "https://github.com" },
  { icon: Youtube, label: "YouTube", href: "https://youtube.com" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative z-10 border-t border-border bg-card/40">
      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8 sm:py-20">
        <div className="mb-14 flex flex-col items-start justify-between gap-6 rounded-3xl border border-border bg-card p-8 sm:flex-row sm:items-center sm:p-10">
          <div>
            <h3 className="font-display text-2xl font-semibold tracking-tight">Stay in the loop.</h3>
            <p className="mt-1.5 text-sm text-muted-foreground">
              Product updates, founder stories and launch news — straight to your inbox.
            </p>
          </div>
          <div className="w-full sm:max-w-sm">
            <NewsletterForm source="footer" />
          </div>
        </div>

        <div className="grid gap-12 lg:grid-cols-[1.4fr_repeat(4,1fr)]">
          <div className="max-w-xs">
            <Logo imgClass="h-8" />
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              The AI-powered Business Operating System. Run your entire business from one connected workspace.
            </p>
            <div className="mt-6 flex items-center gap-2">
              {SOCIALS.map(({ icon: Icon, label, href }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={label}
                  data-testid={`footer-social-${label.toLowerCase()}`}
                  className="inline-flex h-9 w-9 items-center justify-center rounded-full border border-border text-muted-foreground transition-colors hover:border-foreground/30 hover:text-foreground"
                >
                  <Icon className="h-[18px] w-[18px]" />
                </a>
              ))}
            </div>
          </div>

          {Object.entries(FOOTER).map(([group, links]) => (
            <div key={group}>
              <h3 className="eyebrow mb-4 text-muted-foreground">{group}</h3>
              <ul className="space-y-3">
                {links.map((l) => (
                  <li key={l.label + l.to}>
                    <Link
                      to={l.to}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                      data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-border pt-8 text-sm text-muted-foreground sm:flex-row sm:items-center">
          <p>© {new Date().getFullYear()} StUpEco Workspace. All rights reserved.</p>
          <p className="brand-gradient-text font-display font-semibold">Run your business from one connected workspace.</p>
        </div>
      </div>
    </footer>
  );
}
